import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const syncIcon: SvgIconData = {
  viewBox: '8.2 11.2 83.7 77.6',
  element: (
    <path d="m63.1 53.9-6.4 35 35.1-6.3L81.1 72A38 38 0 0 0 56 13.4l-2 11a26.5 26.5 0 0 1 19 39.3zM27.2 36.5l9.7 9.8 6.2-35.1-35 6.3 11 11A38 38 0 0 0 43 88l2-11a26.5 26.5 0 0 1-17.8-40.5" />
  ),
};
